import Axios from 'axios';
import URL from '../config/url';

function getQueryString(name) {
    var search = window.location.search.substring(1)
    if (!search) {
        search = window.location.hash.split('?')[1]
    }
    if (search && search.indexOf('fileUrl')===-1) {
        var obj = JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        return name ? obj[name] : obj
    }
  
  }
const baseURL = URL.API;
const service = Axios.create({withCredentials: true, baseURL})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : getQueryString('token')? getQueryString('token') : null
    if (token) {
        config.headers['token'] = token || ''
    }
    if(getQueryString('token')!=undefined){
        localStorage.setItem("token",getQueryString('token'));
        localStorage.setItem("organ",getQueryString('organ'));
        localStorage.setItem("actor",getQueryString('actor'));
        localStorage.setItem("branch",getQueryString('branch'));
    }
    config.headers['organ'] = localStorage.getItem("organ") ? localStorage.getItem("organ") : getQueryString('organ')? getQueryString('organ'):''
    config.headers['actor'] = localStorage.getItem("actor") ? localStorage.getItem("actor") : getQueryString('actor')? getQueryString('actor'):''
    config.headers['branch'] = localStorage.getItem('branch') ? localStorage.getItem('branch') : getQueryString('branch')? getQueryString('branch'):''
    localStorage.getItem('channel') && (config.headers['channel'] = localStorage.getItem('channel'));
    return config
}, err => {
    return Promise.reject(err)
})

// 响应拦截器
service.interceptors.response.use(response => {
    return response.data
}, err => {
    console.log('出错了~~',err)
    return Promise.reject(err)
})

export default service
